import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Table } from 'antd'

@inject((store: any) => {
    const { insuranceCalculatorStore, popupStore, companiesStore } = store
    return { insuranceCalculatorStore, popupStore, companiesStore }
})
@observer
export default class OverlapsTable extends Component<any, any> {
    render() {
        const { insuranceCalculatorStore, sets, drug, fitleredMainInsuranceCasesShaban, hmoCompanies } = this.props
        let newKefelHeser = insuranceCalculatorStore.newKefelHeser
        const { insuranceCases, loading } = insuranceCalculatorStore

        const columns = [
            {
                title: 'ביטוחים',
                key: 'right_param_set_id',
                render: (_, record) => (
                    <span>
                        {record.right_param_set_id != 20 ? sets[`id${record.right_param_set_id}`] : drug}
                        {checkIfIndeminficationOrCompensation(record)}
                    </span>
                )
            }
        ]
        fitleredMainInsuranceCasesShaban.map((insurance, ind) => {
            columns.push({
                title: `חפיפה בין ${
                    insuranceCases.find(
                        insurance =>
                            insurance.policy_id &&
                            'SHABAN' === insurance.policy_type &&
                            hmoCompanies[insurance.company_id]
                    ).sub_name
                }
                ל${insurance.name}`,
                key: insurance.name,
                render: (_, record) => (
                    <span>
                        {insuranceCases.find(
                            ins =>
                                ins.policy_type === insurance.policy_type &&
                                ins.right_param_set_id == record.right_param_set_id &&
                                ins.company_id == insurance.company_id
                        ) &&
                            Object.values(record.rights)
                                .filter(
                                    right =>
                                        right.exist.length > 1 &&
                                        right.exist.find(rt => hmoCompanies[record.policies[rt].company_id])
                                )
                                .map((right, ind) => {
                                    if (ind == 0 || ind == 1) return <div key={ind}>{right.name}</div>
                                    if (ind == 2)
                                        return (
                                            <div
                                                key={ind}
                                                style={{
                                                    textDecoration: 'underline',
                                                    color: 'blue',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() =>
                                                    this.props.popupStore.togglePopup('clarification', {
                                                        title: `חפיפה בין ${
                                                            insuranceCases.find(
                                                                insurance =>
                                                                    insurance.policy_id &&
                                                                    'SHABAN' === insurance.policy_type &&
                                                                    hmoCompanies[insurance.company_id]
                                                            ).sub_name
                                                        }
                                                            ל${insurance.name}`,
                                                        rights: Object.values(record.rights)
                                                            .filter(
                                                                right =>
                                                                    right.exist.length > 1 &&
                                                                    right.exist.find(
                                                                        rt =>
                                                                            hmoCompanies[record.policies[rt].company_id]
                                                                    )
                                                            )
                                                            .map(right => {
                                                                return { name: right.name }
                                                            })
                                                    })
                                                }
                                            >
                                                קרא עוד...
                                            </div>
                                        )
                                })}
                    </span>
                )
            })
        })
        columns.push({
            title: `ייחודי ב${
                insuranceCases.find(
                    insurance =>
                        insurance.policy_id && 'SHABAN' === insurance.policy_type && hmoCompanies[insurance.company_id]
                ).sub_name
            }`,
            key: 'uniqueShaban',
            render: (_, record) => (
                <span>
                    {Object.values(record.rights)
                        .filter(
                            right => right.exist.length == 1 && hmoCompanies[record.policies[right.exist[0]].company_id]
                        )
                        .map((right, ind) => {
                            if (ind == 0 || ind == 1) return <div key={ind}>{right.name}</div>
                            if (ind == 2)
                                return (
                                    <div
                                        key={ind}
                                        style={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer' }}
                                        onClick={() =>
                                            this.props.popupStore.togglePopup('clarification', {
                                                title: `ייחודי ב${
                                                    insuranceCases.find(
                                                        insurance =>
                                                            insurance.policy_id &&
                                                            'SHABAN' === insurance.policy_type &&
                                                            hmoCompanies[insurance.company_id]
                                                    ).sub_name
                                                }`,
                                                rights: Object.values(record.rights).filter(
                                                    right =>
                                                        right.exist.length == 1 &&
                                                        hmoCompanies[record.policies[right.exist[0]].company_id]
                                                )
                                            })
                                        }
                                    >
                                        קרא עוד...
                                    </div>
                                )
                        })}
                </span>
            )
        })
        columns.push({
            title: 'הבהרה',
            key: 'clarification',
            render: (_, record) => <span />
        })
        let rows = newKefelHeser.sets
            ? Object.entries(newKefelHeser.sets)
                  .filter(
                      ([key, value]) =>
                          key != 9 &&
                          key != 14 &&
                          key != 19 &&
                          value.policies.length > 1 &&
                          value.policies.find(policy => hmoCompanies[policy.company_id])
                  )
                  .map(([key, value]) => {
                      value.right_param_set_id = key
                      return value
                  })
            : []

        const getDuplicateRights = (insurance, value, key) => {
            const { insuranceCalculatorStore, hmoCompanies } = this.props
            const { insuranceCases } = insuranceCalculatorStore
            let rights = []
            if (
                insuranceCases.find(
                    ins =>
                        ins.policy_type === insurance.policy_type &&
                        ins.right_param_set_id == key &&
                        ins.company_id == insurance.company_id
                )
            ) {
                const cloneRights = value.rights ? JSON.parse(JSON.stringify(value.rights)) : []
                rights = Object.entries(cloneRights)
                    .filter(
                        ([id, right]) =>
                            right.exist.length > 1 &&
                            right.exist.find(rt => hmoCompanies[value.policies[rt].company_id])
                    )
                    .map(([id, right]) => {
                        const policy1 =
                            value.policies[right.exist.find(policy => hmoCompanies[value.policies[policy].company_id])]
                        const policy2 =
                            value.policies[
                                right.exist.find(policy => value.policies[policy].policy_id == insurance.policy_id)
                            ]
                        right.indemnification =
                            (policy1 && policy1.rights[id] == 'שיפוי') || (policy2 && policy2.rights[id] == 'שיפוי')
                        right.compensation =
                            (policy1 && policy1.rights[id] == 'פיצוי') || (policy2 && policy2.rights[id] == 'פיצוי')
                        return right
                    })
            }
            return rights
        }

        const getUniqueRights = value => {
            const { hmoCompanies } = this.props
            const cloneRights = JSON.parse(JSON.stringify(value.rights))
            return Object.entries(cloneRights)
                .filter(
                    ([id, right]) => right.exist.length == 1 && hmoCompanies[value.policies[right.exist[0]].company_id]
                )
                .map(([id, right]) => {
                    right.indemnification =
                        value.policies[right.exist.find(policy => hmoCompanies[value.policies[policy].company_id])]
                            .rights[id] == 'שיפוי'
                    right.compensation =
                        value.policies[right.exist.find(policy => hmoCompanies[value.policies[policy].company_id])]
                            .rights[id] == 'פיצוי'
                    return right
                })
        }

        const checkIfIndeminficationOrCompensation = value => {
            const { fitleredMainInsuranceCasesShaban } = this.props
            const uniqueRights = getUniqueRights(value)
            let duplicateRights = []
            fitleredMainInsuranceCasesShaban.map(insurance =>
                duplicateRights.push(getDuplicateRights(insurance, value, value.right_param_set_id))
            )
            let indemnification = true
            let compensation = true
            const rights = [...uniqueRights, ...duplicateRights.flat()]
            rights.map(right => {
                if (right.compensation) indemnification = false
                else if (right.indemnification) compensation = false
            })
            return indemnification ? (
                <div>
                    (<span className="green">שיפוי</span>)
                </div>
            ) : compensation ? (
                <div>
                    (<span className="blue">פיצוי</span>)
                </div>
            ) : (
                <div>
                    (<span className="green">שיפוי</span> /<span className="blue">פיצוי</span>)
                </div>
            )
        }
        return (
            <Table
                className="center-table"
                style={{ width: '100%' }}
                rowKey="id"
                loading={loading}
                columns={columns}
                dataSource={rows}
            />
        )
    }
}
